import CampaignConsent from './CampaignConsent';
import CampaignOptOut from './CampaignOptOut';

export { CampaignConsent, CampaignOptOut };
